import React, { useState } from "react";
import {
    Box,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { logos } from "../../../../constants/Home/parceiros";

const BrandCarousel = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMiddle = useMediaQuery(theme.breakpoints.down('md'));

    const itemsPerPage = isMobile ? 2 : isMiddle ? 3 : 4;
    const itemWidth = isMobile ? 70 : 110; 
    const gap = isMobile ? 46 : 54;
    const totalItems = logos.length;
    
    const maxIndex = Math.max(totalItems - itemsPerPage, 0);

    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex(prev => Math.max(prev - 1, 0));
    };

    const handleNext = () => {
        setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
    };

    return (
        <Box sx={{ backgroundColor: "#170C66", py: 6, mt: isMobile ? '4rem' : 0 }}>
            <Typography
                variant="h5"
                fontWeight="bold"
                color="white"
                textAlign="center"
                mb={4}
                sx={{
                    fontSize: isMobile ? "18px" : "24px",
                }}
            >
                QUAIS MARCAS JÁ ESTÃO COM <br />
                SEUS CLUBES DE BENEFÍCIOS?
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    maxWidth: "790px",
                    mx: "auto",
                    gap: 2,
                    px: 2, 
                    width: '100%',
                    boxSizing: 'border-box'
                }}
            >
                <IconButton 
                    onClick={handlePrev} 
                    disabled={currentIndex === 0} 
                    sx={{ 
                        color: "#F5C525",
                        visibility: currentIndex === 0 ? "hidden" : "visible",
                    }}
                >
                    <ArrowBackIosNewIcon />
                </IconButton>

                <Box
                    sx={{
                        overflow: "hidden",
                        flex: 1,
                        width: '100%',
                        maxWidth: isMobile ? `${(itemWidth + gap) * itemsPerPage}px` : "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: `${gap}px`,
                            transition: "transform 0.3s ease",
                            transform: `translateX(-${currentIndex * (itemWidth + gap)}px)`,
                        }}
                    >
                        {logos.map((logo, index) => (
                            <Box
                                key={`${logo.alt}-${index}`}
                                sx={{
                                    flexShrink: 0,
                                    width: `${itemWidth}px`,
                                }}
                            >
                                <a
                                    href={logo.link || "#"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none" }}
                                >
                                    <Box
                                        sx={{
                                            background: "#fff",
                                            borderRadius: 3,
                                            padding: 2,
                                            width: `${itemWidth}px`,
                                            height: isMobile ? "90px" : "90px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "transform 0.2s ease",
                                        }}
                                    >
                                        <img
                                            src={logo.url}
                                            alt={logo.alt}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                cursor: "pointer",
                                            }}
                                        />
                                    </Box>
                                </a>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <IconButton
                    onClick={handleNext}
                    disabled={currentIndex === maxIndex}
                    sx={{ 
                        color: "#F5C525",
                        visibility: currentIndex === maxIndex ? "hidden" : "visible",
                    }}
                >
                    <ArrowForwardIosIcon />
                </IconButton>
            </Box>
        </Box>
    );
};
export default BrandCarousel;
